import React, {Component} from "react";
import './LogAnalytics.scss';
import LogFieldResponse from "../reports/dynamic-form/LogFieldResponse";
import Checkbox from "../../../shared/forms/Checkbox";

let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});

class LogAnalytics extends Component {
  constructor(props) {
    super(props);

    this.state = {
      opened: {},
      showAllRecords: false
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(JSON.stringify(prevProps.selectedPhasesMap) !== JSON.stringify(this.props.selectedPhasesMap)) {
      this.groupLogsMap = {}
    }
  }

  groupLogsMap = {}

  groupLogs(lr, groupBy, user) {
    let logReport = lr;
    // let groupBy = logReport.logField.groupBy;
    if(this.groupLogsMap[logReport.logField.id + groupBy + user.guid + this.state.showAllRecords.toString() + this.props.searchValue]) {
      return this.groupLogsMap[logReport.logField.id + groupBy + user.guid + this.state.showAllRecords.toString()  + this.props.searchValue]
    }

    let scoreField = logReport.logField.fields.findIndex(f => f.type === 'score');

    let groupByMap =logReport.logField.fields[groupBy]
      ? logReport.logField.fields[groupBy].options.reduce((acc, o) => ({...acc, [o.value]: []}), {})
      : {}
    let groupedLogs = logReport.list
      .filter((log) => {
        // console.log('LOGG', log)
        if(this.props.selectedPhasesMap) {
          return this.props.selectedPhasesMap[log.trainingPhaseGuid]
        }
        return true
      })
      .reduce((acc, log) => {
      if(log[groupBy] && log.groupBy && ((Array.isArray(log.groupBy) && log.groupBy.includes(groupBy)) || (!Array.isArray(log.groupBy) && log.groupBy === groupBy))) {

        // console.log('this.props.search',this.props.searchValue, log[groupBy].includes(this.props.searchValue))
        if(!this.props.searchValue || (this.props.searchValue && log[groupBy].includes(this.props.searchValue))) {
          if(scoreField > -1) {
            log.score = log[scoreField]
          }
          return {
            ...acc,
            [log[groupBy]]: [
              ...(acc[log[groupBy]] || []),
              log
            ]
          }
        }
        return acc
      }
      return acc
    }, groupByMap);

    let groupLogs = Object.keys(groupedLogs)
      .map((key) => ({
        key,
        count: groupedLogs[key].length,
        list: groupedLogs[key],
        hasScore: scoreField > -1,
        totalScored: groupedLogs[key].filter(l => l.score != null && l.score != undefined && parseInt(l.score)).length,
        totalScore: groupedLogs[key].filter(l => l.score != null && l.score != undefined && parseInt(l.score)).reduce((sum, l) => sum + (parseInt(l.score) || 0), 0)
      }))
      .sort((q1, q2) => {
        let sortPropA = q1.key;
        let sortPropB = q2.key;
        return collator.compare(sortPropA, sortPropB);
      })
      .map((l) => ({
        ...l,
        key: l.key.split('_').join(' ')
      }))
      .filter((l) => {
        if(this.state.showAllRecords) {
          return true
        }
        return l.count > 0
      });

    this.groupLogsMap[logReport.logField.id + groupBy + user.guid + this.state.showAllRecords.toString() + this.props.searchValue] = groupLogs

    return groupLogs;
  }

  percentage(groupedLogs, count) {
    let total = groupedLogs.reduce((sum, gl) => sum + gl.count, 0)
    if(!total) {
      return 0
    }

    return Math.round((count/total) * 100)
  }

  isOpened(group) {
    return this.state.opened[group]
  }

  toggleGroup(group) {
    this.setState({
      opened: {
        ...this.state.opened,
        [group]: !this.state.opened[group]
      }
    })
  }

  getGroups(lr) {
    let groupBy = lr.logField.groupBy;
    if(!Array.isArray(groupBy)) {
      groupBy = groupBy !== null ? [groupBy]: []
    }
    return groupBy.filter(gb => gb !== null)
  }

  getGroupName(lr, group) {
    try {
      return lr.logField.fields[group].label
    } catch (ex) {
      return "N/A"
    }
  }


  render() {
    return (
      <div className="log-analytics">
        {this.props.reportAnalytics.map(ra => (
          <div key={ra.user.guid} className="log-analytics-user">
            {ra.reportAnalytics.logReport.map((log) => (
              <div key={ra.user.guid + log.logField.form_title}>
                <div className="log-analytics-header"><span>{ra.user.getFullName()}</span>
                  <Checkbox
                    label={`Show ALL ${log.logField.form_title} records`}
                    checked={this.state.showAllRecords}
                    onChange={(e) => this.setState({showAllRecords: e.target.checked})}
                  />
                </div>
                {this.getGroups(log) && this.getGroups(log).map((group) => (
                  <div key={group + log.logField.form_title}>
                    <div className="group-name"><b>{this.getGroupName(log, group)}</b></div>
                    {this.groupLogs(log, group, ra.user).map(lr => (
                      <div key={lr.key + ra.user.guid} className="log-analytics-group" onClick={() => this.toggleGroup(lr.key + ra.user.guid)}>
                        <div className="log-analytics-group-header">
                          <span>{lr.key}</span>
                          <span>{lr.hasScore && lr.totalScored > 0 ?<span>Avg. Score: {(lr.totalScore/lr.totalScored).toFixed(2)}</span>:null} Occurrences: {lr.count} <i>({this.percentage(this.groupLogs(log, group, ra.user), lr.count)}%)</i>
                            {!this.isOpened(lr.key + ra.user.guid) && <i className="fa fa-chevron-down"></i>}
                            {this.isOpened(lr.key + ra.user.guid) && <i className="fa fa-chevron-up"></i>}
                      </span>
                        </div>
                        {this.isOpened(lr.key + ra.user.guid) && <LogFieldResponse
                          element={log.logField}
                          isEdit={false}
                          value={lr}
                          reportClick={(viewingReport) => this.props.reportClick(viewingReport)}
                        />}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>
    )
  }
}

export default LogAnalytics;
